























































import { Component, Prop, Vue } from 'vue-property-decorator';
import ProductPropertyType from '@/interfaces/ProductPropertyType';

@Component
export default class ProductProperty extends Vue {
  @Prop() private inputType!: string;

  @Prop() private productProperty!: ProductPropertyType;

  emitValue() {
    this.$emit('update:productProperty', this.productProperty);
  }
}
